import { createSlice } from '@reduxjs/toolkit'

const toResourcesByType = resources => (resources && !Array.isArray(resources) ? resources : {})

const initialState = {
  items: [],
  resources: {},
  loaded: false,
  isLoading: false,
  error: null,
  search: '',
  page: 1,
  pageSize: 10,
  sortKey: 'id',
  sortDirection: 'ASC',
  actionLoadingId: null,
  showOnlyDeleted: false,
  showOnlyActive: false,
  confirmAction: null,
  selectedProductType: null,
  isSavingResources: false,
}

const slice = createSlice({
  name: 'additionalProductsTools',
  initialState,
  reducers: {
    reset: () => initialState,
    setSearch: (state, { payload }) => {
      state.search = payload
      state.page = 1
    },
    setPage: (state, { payload }) => {
      state.page = payload
    },
    toggleSort: (state, { payload: key }) => {
      if (state.sortKey === key) {
        state.sortDirection = state.sortDirection === 'ASC' ? 'DESC' : 'ASC'
      } else {
        state.sortKey = key
        state.sortDirection = 'ASC'
      }
    },
    setShowOnlyDeleted: state => {
      const next = !state.showOnlyDeleted
      state.showOnlyDeleted = next
      if (next) state.showOnlyActive = false
      state.page = 1
    },
    setShowOnlyActive: state => {
      const next = !state.showOnlyActive
      state.showOnlyActive = next
      if (next) state.showOnlyDeleted = false
      state.page = 1
    },
    setConfirmAction: (state, { payload }) => {
      state.confirmAction = payload
    },
    setSelectedProductType: (state, { payload }) => {
      state.selectedProductType = payload
    },
    // list fetch lifecycle
    fetchListRequest: state => {
      state.isLoading = true
      state.error = null
    },
    fetchListSuccess: (state, { payload }) => {
      state.isLoading = false
      state.items = payload?.data || []
      state.resources = toResourcesByType(payload?.resources)
      state.loaded = true
    },
    fetchListFailure: (state, { payload }) => {
      state.isLoading = false
      state.error = payload || 'Error'
    },
    // delete / restore lifecycle
    deleteRequest: (state, { payload: id }) => {
      state.actionLoadingId = id
    },
    deleteSuccess: (state, { payload: { id, date } }) => {
      state.actionLoadingId = null
      state.items = state.items.map(i => (i.id === id ? { ...i, deleted_at: date } : i))
    },
    deleteFailure: state => {
      state.actionLoadingId = null
    },
    restoreRequest: (state, { payload: id }) => {
      state.actionLoadingId = id
    },
    restoreSuccess: (state, { payload: id }) => {
      state.actionLoadingId = null
      state.items = state.items.map(i => (i.id === id ? { ...i, deleted_at: null } : i))
    },
    restoreFailure: state => {
      state.actionLoadingId = null
    },
    updateResourceOfProductType: (state, { payload: { productType, resources } }) => {
      state.resources[productType] = [...resources]
    },
    setIsSavingResources: (state, { payload: value }) => {
      state.isSavingResources = value
    },
  },
})

export const {
  reset,
  setSearch,
  setPage,
  toggleSort,
  setShowOnlyDeleted,
  setShowOnlyActive,
  setConfirmAction,
  fetchListRequest,
  fetchListSuccess,
  fetchListFailure,
  deleteRequest,
  deleteSuccess,
  deleteFailure,
  restoreRequest,
  restoreSuccess,
  restoreFailure,
  setSelectedProductType,
  updateResourceOfProductType,
  setIsSavingResources,
} = slice.actions

export default slice.reducer
